import { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
  IconButton,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseSendSMS } from "./UseSendSMS";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CustomPagination from "../../components/CustomPagination";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import DeleteRow from "../../components/DeleteRow";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function CreateSMS(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetMessages, setTemplate, deleteTemplate, validate2 } = UseSendSMS();
  const [BunchRes, setTemplateRes] = useState([]);
  const [state, setState] = useState({
    id: 0,
    message: undefined,
    title: undefined,
  });
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  const [errorState, setErrorState] = useState({
    message: false,
    title: false,
  });
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (props.expanded === "SMS3") {
      setProgress(true);
      GetMessages(true, (callback) => {
        setTemplateRes(callback);
      });
    } else {
      setState({
        title: undefined,
        message: undefined,
        id: 0,
      });
      setTemplateRes([]);
    }
  }, [props.expanded]);

  const handleChange = (panel) => (event, isExpanded) => {
    props.setExpanded(isExpanded ? panel : false);
    if (isExpanded) {
      const element = document.getElementById("SMS3");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  };

  const columns = [
    {
      field: "id",
      width: 90,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "عنوان",
      width: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "message",
      headerName: "پیام",
      width: 400,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {cellValues.row.message
              .replace(/(<([^>]+)>)/gi, "")
              .replace(/(&nbsp;)/gi, " ")}
          </Typography>
        );
      },
    },
    {
      field: "count",
      headerName: "پارامتر",
      width: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.value1 == true ||
            cellValues.row.value2 == true ||
            cellValues.row.value3 == true ||
            cellValues.row.value4 == true ||
            cellValues.row.value5 == true ||
            cellValues.row.value6 == true ||
            cellValues.row.value7 == true ||
            cellValues.row.value8 == true ||
            cellValues.row.value9 == true ||
            cellValues.row.value10 == true ||
            cellValues.row.value11 == true ||
            cellValues.row.value12 == true ||
            cellValues.row.value13 == true ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 100,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box>
            <Tooltip title="Delete">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  setState({
                    id: cellValues.row.id,
                    title: cellValues.row.title,
                    message: cellValues.row.message,
                    //   .replace(/(<([^>]+)>)/gi, "")
                    //   .replace(/(&nbsp;)/gi, " "),
                  });
                }}
              >
                <EditIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
  ];

  return (
    <Accordion
      id="SMS3"
      expanded={props.expanded === "SMS3"}
      onChange={handleChange("SMS3")}
      style={{
        paddingBottom: "15px",
        marginTop: "30px",
      }}
    >
      <AccordionSummary
        // onClick={() => props.setExpanded("panel1")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FiberManualRecordIcon color="secondary" fontSize="small" />
          <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
            ایجام پیام SMS
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ height: "30rem" }}>
          <DataGrid
            className="ltr-grid"
            localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
            columns={columns}
            rows={BunchRes}
            pageSize={20}
            Pagination
            onPageChange={(newPage) => {
              setPageState((old) => ({ ...pageState, page: newPage + 1 }));
            }}
            rowCount={BunchRes ? BunchRes.length : 1}
            enableRangeSelection={true}
            disableColumnMenu
            hideFooterSelectedRowCount
            components={{
              Pagination: CustomPagination,
            }}
            componentsProps={{
              pagination: {
                nofab: true,
                // noPage: true,
                isLtr: true,
                rowCount: BunchRes ? BunchRes.length : "",
              },
            }}
            initialState={{
              sorting: {
                sortModel: [
                  {
                    field: "id",
                    sort: "asc",
                  },
                ],
              },
            }}
          />
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", my: 3, gap: 2 }}>
          <TextField
            sx={{ width: isSmall ? "80%" : "30%" }}
            fullWidth
            value={state.title ? state.title : ""}
            onChange={(event) => {
              setState({ ...state, title: event.target.value });
            }}
            label="عنوان"
            size="small"
            variant="outlined"
            error={errorState.title}
          />
          <TextField
            fullWidth
            value={state.message ? state.message : ""}
            onChange={(event) => {
              setState({ ...state, message: event.target.value });
            }}
            label="پیام"
            size="small"
            multiline
            // rows={3}
            maxRows={10}
            variant="outlined"
            error={errorState.message}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 2,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setState({ title: undefined, message: undefined, id: 0 });
            }}
          >
            جدید
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              if (validate2(state, setErrorState) == 200) {
                setProgress(true);
                setTemplate(state, () => {
                  setState({
                    title: undefined,
                    message: undefined,
                    id: 0,
                  });
                  GetMessages(true, (callback) => {
                    setTemplateRes(callback);
                  });
                });
              }
            }}
          >
            ثبت
          </Button>
        </Box>
        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={"پیام با عنوان"}
          callback={() => {
            setProgress(true);
            deleteTemplate(deleteState.id, () => {
              GetMessages(true, (callback) => {
                setTemplateRes(callback);
              });
            });
          }}
        ></DeleteRow>
      </AccordionDetails>
    </Accordion>
  );
}
